export default __webpack_public_path__ + "static/media/avatar_dummy.22c31152.png";